import { ISelectOptionDTO } from "@hooks/dtos/forms/ISelectDTO";
import {
  IRaffleRewardClaimDeliveryTypeBadgeDTO,
  IRaffleRewardClaimStatusBadgeDTO,
} from "@hooks/dtos/raffles/IRaffleRewardClaimDTO";
import {
  RaffleRewardClaimDeliveryTypeEnum,
  RaffleRewardClaimDeliveryTypes,
  RaffleRewardClaimStatusEnum,
  RaffleRewardClaimStatusTypes,
} from "@hooks/enums/raffle_reward_claim";

export const raffleRewardClaimStatusTypes: IRaffleRewardClaimStatusBadgeDTO[] =
  [
    {
      status: RaffleRewardClaimStatusEnum.WAITING_REQUEST,
      text: "Aguardando solicitação",
      title: "Este prêmio ainda precisa ser solicitado.",
      color: "warning",
    },
    {
      status: RaffleRewardClaimStatusEnum.REQUESTED,
      text: "Solicitado",
      title: "A solicitação deste prêmio foi enviada.",
      color: "primary",
    },
    {
      status: RaffleRewardClaimStatusEnum.APPROVED,
      text: "Aprovado",
      title: "A solicitação deste prêmio foi aprovada.",
      color: "info",
    },
    {
      status: RaffleRewardClaimStatusEnum.PENDING_INFORMATION,
      text: "Pendente de informação",
      title: "Este prêmio precisa de informações adicionais.",
      color: "warning",
    },
    {
      status: RaffleRewardClaimStatusEnum.SENT,
      text: "Enviado/Pago",
      title: "O proprietário marcou este prêmio como enviado ou pago.",
      color: "success",
    },
    {
      status: RaffleRewardClaimStatusEnum.DELIVERED,
      text: "Entregue",
      title: "Este prêmio foi entregue ou confirmado.",
      color: "success",
    },
    {
      status: RaffleRewardClaimStatusEnum.QUESTIONED,
      text: "Contestado",
      title: "Este prêmio foi contestado pelo cliente.",
      color: "danger",
    },
    {
      status: RaffleRewardClaimStatusEnum.CANCELED,
      text: "Cancelado",
      title: "Este prêmio foi cancelado.",
      color: "secondary",
    },
    {
      status: RaffleRewardClaimStatusEnum.EXCLUDED,
      text: "Excluído",
      title: "Este prêmio foi excluído.",
      color: "danger",
    },
  ];

export const raffleRewardClaimDeliveryTypeTypes: IRaffleRewardClaimDeliveryTypeBadgeDTO[] =
  [
    {
      type: RaffleRewardClaimDeliveryTypeEnum.SHIPPING,
      text: "Envio",
      title: "Entrega por envio.",
      color: "primary",
    },
    {
      type: RaffleRewardClaimDeliveryTypeEnum.PIX,
      text: "PIX",
      title: "Entrega por pagamento via PIX.",
      color: "success",
    },
    {
      type: RaffleRewardClaimDeliveryTypeEnum.BANK,
      text: "Banco",
      title: "Entrega por transferência bancária.",
      color: "success",
    },
    {
      type: RaffleRewardClaimDeliveryTypeEnum.PICKUP,
      text: "Retirada",
      title: "Entrega por retirada presencial.",
      color: "info",
    },
    {
      type: RaffleRewardClaimDeliveryTypeEnum.DIGITAL,
      text: "Digital",
      title: "Entrega digital.",
      color: "info",
    },
    {
      type: RaffleRewardClaimDeliveryTypeEnum.MANUAL,
      text: "Manual",
      title: "Entrega manual definida pelo proprietário.",
      color: "secondary",
    },
    {
      type: RaffleRewardClaimDeliveryTypeEnum.OTHER,
      text: "Outro",
      title: "Outro tipo de entrega.",
      color: "secondary",
    },
  ];

export function getRaffleRewardClaimStatus(
  status: RaffleRewardClaimStatusTypes,
): IRaffleRewardClaimStatusBadgeDTO {
  let ret = raffleRewardClaimStatusTypes.find((item) => item.status === status);
  if (!ret) ret = { status: "", text: "Erro", title: "Erro", color: "danger" };
  return ret;
}

export function getRaffleRewardClaimDeliveryType(
  type: RaffleRewardClaimDeliveryTypes,
): IRaffleRewardClaimDeliveryTypeBadgeDTO {
  let ret = raffleRewardClaimDeliveryTypeTypes.find((item) => item.type === type);
  if (!ret) ret = { type: "", text: "Erro", title: "Erro", color: "danger" };
  return ret;
}

export const raffleRewardClaimStatusSelect: ISelectOptionDTO[] = [
  { value: "", name: "Todos" },
  ...raffleRewardClaimStatusTypes.map((item) => ({
    value: item.status,
    name: item.text,
    description: item.title,
  })),
];

export const raffleRewardClaimDeliveryTypeSelect: ISelectOptionDTO[] = [
  { value: "", name: "Todos" },
  ...raffleRewardClaimDeliveryTypeTypes.map((item) => ({
    value: item.type,
    name: item.text,
    description: item.title,
  })),
];
